import { render, staticRenderFns } from "./courseGoods.vue?vue&type=template&id=6911c9fd&scoped=true"
import script from "./courseGoods.vue?vue&type=script&lang=js"
export * from "./courseGoods.vue?vue&type=script&lang=js"
import style0 from "./courseGoods.vue?vue&type=style&index=0&id=6911c9fd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6911c9fd",
  null
  
)

export default component.exports